import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();
  useSeo({
    title: "页面未找到 - 赏金女王影视大全",
    description: "抱歉，你访问的页面不存在，请返回首页继续浏览影视作品与资讯。",
  });

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <h1 className="absolute bottom-10 text-8xl md:text-[11rem] font-black text-background-200 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <span className="w-16 h-16 mx-auto rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-3xl mb-5">
          <i className="ri-emotion-sad-line" aria-hidden="true"></i>
        </span>
        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm text-foreground-500 break-all">{location.pathname}</p>
        <p className="mt-2 text-base text-foreground-600">该页面不存在或已被移除</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-6 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
          <Link
            to="/category/tv"
            className="px-6 py-2.5 rounded-md border border-background-300 text-sm text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览电视剧
          </Link>
        </div>
      </div>
    </div>
  );
}